// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__1XsAB","Icon":"Languages_Icon__2E_UU","LanguagesSelect":"Languages_LanguagesSelect__3GLDC","minimalist":"Languages_minimalist__3N0vN"};